import { render } from "./AddNewQuestButton.vue?vue&type=template&id=fed22d8a&scoped=true"
import script from "./AddNewQuestButton.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddNewQuestButton.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddNewQuestButton.vue?vue&type=style&index=0&id=fed22d8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed22d8a"]])

export default __exports__